import React, { createContext, useMemo } from 'react';

// eslint-disable-next-line no-spaced-func
export const NavbarDropdownSelectedItemContext = createContext<{
  id: string,
  setId: (a: string) => void
}>({ id: '', setId: () => { } });

export function NavbarDropdownSelectedItemProvider({ children }: { children: React.ReactNode }) {
  const [id, setId] = React.useState<string>('');
  const setSelectedId = (newId: string) => { setId(newId); };
  const value = useMemo(() => ({
    id,
    setId: setSelectedId,
  }), [id]);

  return (
    <NavbarDropdownSelectedItemContext.Provider
      value={value}
    >
      {children}
    </NavbarDropdownSelectedItemContext.Provider>
  );
}
